import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert} from 'Components/Partials';
import {FormHandler, Input, FileUpload, Select} from 'Components/Form';
import {PrimaryButton} from 'Components/Button';

import DownloadApi from 'Services/Api/Exhibitor/Download';

class UpdateDownload extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your downloads have been updated';

    /**
     * @var actions
     * @type {[{label: string, value: string}, {label: string, value: string}]}
     */
    actions = [
        {label: 'Download', value: 'download'},
        {label: 'Open', value: 'open'},
    ];

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        const {setForm, download} = this.props;

        let form = {};

        if (download) {
            form = {
                ...download
            };
        } else {
            form = {
                name: '',
                src: null,
                action: '',
            };
        }

        setForm(form);
    }

    /**
     * @method handleSubmit
     * @param {Event} e
     */
    handleSubmit = async (e) => {
        e.preventDefault();

        const {form, setAlert, setWorking, exhibitor, download, submitCallback} = this.props;

        setWorking(true);

        let response = null;

        if (download) {
            response = await DownloadApi.updateDownload(download.id, form);
        } else {
            response = await DownloadApi.storeDownload({
                ...form,
                exhibitor_id: exhibitor.id
            });
        }

        if (!response.success) {
            setAlert('error', response.message, response.errors);
            setWorking(false);
            return false;
        } else {
            setAlert('success', this.success, {});
            submitCallback();
            this.props.onClose();
        }
    };

    /**
     * @method handleDelete
     */
    handleDelete = async () => {
        const {setAlert, setWorking, download, submitCallback} = this.props;

        setWorking(true);

        let response = await DownloadApi.delete(download.id);

        setAlert('success', 'Item deleted', {});
        setWorking(false);

        submitCallback();

        this.props.onClose();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, handleInput, getFieldError, alert, working, download} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    {download ? 'Update' : 'Submit'} your download
                </ModalHeader>

                <form onSubmit={e => this.handleSubmit(e)}>
                    <ModalBody>
                        <p className="text-center mb-4">
                            Add files for delegates to be able to download or view online.
                        </p>

                        {alert && (<Alert {...alert} />)}

                        <Input
                            containerClassName="my-4"
                            labelColour="text-app-blue"
                            label="Name"
                            type="text"
                            value={form.name}
                            error={getFieldError('name')}
                            onChange={v => handleInput('name', v)}
                        />

                        <FileUpload
                            containerClassName="my-4"
                            label="Src"
                            value={form.src}
                            error={getFieldError('src')}
                            onChange={v => handleInput('src', v)}
                            accept='image/*,video/*,application/pdf'
                            placeholder={download ? 'Update file' : 'Select file'}
                        />

                        <Select
                            containerClassName="my-4"
                            label="Action"
                            value={form.action}
                            error={getFieldError('action')}
                            onChange={v => handleInput('action', v)}
                            options={this.actions}
                        />
                    </ModalBody>

                    <ModalFooter alignment="center">
                        <PrimaryButton
                            text="Close"
                            onClick={this.props.onClose}
                            className="mr-2"
                        />

                        {download &&
                            <PrimaryButton
                                className="ml-2"
                                text="Delete"
                                onClick={this.handleDelete}
                                disabled={working}
                                working={working}
                            />
                        }

                        <PrimaryButton
                            className="ml-2"
                            text={download ? 'Update' : 'Submit'}
                            disabled={working}
                            working={working}
                        />
                    </ModalFooter>
                </form>
            </Modal>
        )
    }
}

export default FormHandler(UpdateDownload);
